import {RelativeFilterConfigBody} from '@dms/api/core';

import {emptyRelativeFilterConfig} from './emptyRelativeFilterConfig';

/**
 * Create-mode defaults for the preset editor. Deliberately separate from
 * {@link emptyRelativeFilterConfig}: “empty” is the neutral no-constraints shape the
 * API returns and tests compare against, while this carries product defaults that
 * apply only to a preset being created (T20-136338).
 */
export function newPresetDefaultConfig(): RelativeFilterConfigBody {
  return {
    ...emptyRelativeFilterConfig(),
    mileageSnapToServerSteps: true,
  };
}
